import { type ActionType, createAction } from 'typesafe-actions';
import { CANCEL, OK, SHOW_ALERT, SHOW_CONFIRM } from './action-types';
import type { ShowConfirmParams } from './types';

export const showConfirm = createAction(SHOW_CONFIRM)<ShowConfirmParams>();
export type ShowConfirm = typeof showAlert;
export const showAlert = createAction(SHOW_ALERT)<ShowConfirmParams>();
export const ok = createAction(OK)();
export const cancel = createAction(CANCEL)();

export type ConfirmActionType =
  | ActionType<typeof showConfirm>
  | ActionType<typeof showAlert>
  | ActionType<typeof ok>
  | ActionType<typeof cancel>;
